export default {
  getOrder: {
    method: 'post',
    url: '/client/report/order'
  },
  getVehicle: {
    method: 'post',
    url: '/client/report/vehicle'
  },
  getDriver: {
    method: 'post',
    url: '/client/report/driver'
  },
  getCustomer: {
    method: 'post',
    url: '/client/report/customer'
  },
  getSale: {
    method: 'post',
    url: '/client/report/sale'
  },
  getSaleKpi: {
    method: 'post',
    url: '/client/report/sale/kpi'
  },
  getPartner: {
    method: 'post',
    url: '/client/report/partner'
  },
  getDistribution: {
    method: 'post',
    url: '/client/report/distribution'
  },
  getRoute: {
    method: 'post',
    url: '/client/report/route'
  },
  getTrip: {
    method: 'post',
    url: '/client/report/trip'
  },
  getJourney: {
    method: 'post',
    url: '/client/report/journey'
  },
  getWorkflow: {
    method: 'post',
    url: '/client/report/workflow'
  },
  getOpportunity: {
    method: 'post',
    url: '/client/report/opportunity'
  },
  getTask: {
    method: 'post',
    url: '/client/report/task'
  },
  getTollStation: {
    method: 'post',
    url: '/client/report/toll-station'
  },
  getTollStationVehicle: {
    method: 'post',
    url: '/client/report/toll-station-vehicle'
  }

}
